import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LinkEnhancer } from "@commerce-core/react-components";
import "@/assets/css/index.css";
import App from "./App.tsx";

createRoot(document.getElementById("react-app")!).render(
  <StrictMode>
    <LinkEnhancer>
      <App />
    </LinkEnhancer>
  </StrictMode>,
);
